import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}




// WEBPACK FOOTER //
// ./src/app/main.component.ts